/*------------------------------------*\
    MODULES
\*------------------------------------*/
// import $ from "jquery";
import mediumZoom from 'medium-zoom';
import getBreakpoint from "../helpers/get-breakpoint";

/*------------------------------------*\
    ZOOMED IMG
\*------------------------------------*/
class ZoomedImg {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;

        self.mobileBreakpoints = ['md', 'lg', 'xl'];
    }

    init() {
        let self = this;

        const img = self.elem.querySelectorAll('[zoomed-img]');

        let screenWidth = window.innerWidth;

        self.elem.children[0].addEventListener("click", (e) => {
            //img.click();
        });

        document.getElementById('zoom-btn').addEventListener("click", (e) => {
            document.getElementById('zoomed-img').click();
        });

        if (self.mobileBreakpoints.includes(getBreakpoint())) {
            mediumZoom(img);
        }
    }

}

export default ZoomedImg;